import Rollbar from 'rollbar/dist/rollbar.umd';

const rollbarConfig = {
  accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.ROLLBAR_ENV || process.env.NODE_ENV,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.VUE_APP_VERSION,
        guess_uncaught_frames: true,
      },
    },
  },
};

const ErrorReporter = Rollbar.init(rollbarConfig);

export default ErrorReporter;
